import { Id, Store } from '@nextforce/api'
import { SearchBarBaseProps } from '@rneui/base/dist/SearchBar/types'
import { SearchBar as _SearchBar, makeStyles } from '@rneui/themed'
import React, { useState } from 'react'
import { FlatList, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { StoreItem } from 'shared/components/store_item'

// WORKAROUND for React Native Elements 3.4.2 https://github.com/@rneui/themed/@rneui/themed/issues/3089#issuecomment-864570123
const SearchBar = _SearchBar as unknown as React.FC<SearchBarBaseProps>

type Props = {
  stores?: Store[] | undefined
  activeStoreId?: Id
  onChoose(store: Store): void
}

export function StoreChooserView({ stores, activeStoreId, onChoose }: Props) {
  const styles = useStyles()
  const [searchText, setSearchText] = useState('')

  if (!stores) {
    return null
  }

  let filteredStores = stores.sort(
    (store1, store2) => Number(store1.storeNumber) - Number(store2.storeNumber)
  )

  if (searchText.length > 0) {
    const searchTextUpper = searchText.toUpperCase()
    filteredStores = stores.filter(
      s =>
        s.name.toUpperCase().startsWith(searchTextUpper) ||
        String(s.storeNumber).startsWith(searchTextUpper) ||
        s.address?.toUpperCase().startsWith(searchTextUpper)
    )
  }

  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.root}>
      <View style={styles.container}>
        <SearchBar
          placeholder="Search"
          onChangeText={setSearchText}
          value={searchText}
          containerStyle={styles.searchBarContainer}
          inputContainerStyle={styles.searchBarnputContainer}
        />
        <FlatList
          keyExtractor={store => store.id}
          data={filteredStores}
          renderItem={({ item: store }) => {
            const isSelected = activeStoreId === store.id

            return (
              <StoreItem
                store={store}
                isSelected={isSelected}
                onSelect={() => onChoose(store)}
              />
            )
          }}
          contentContainerStyle={styles.listContentContainer}
        />
      </View>
    </SafeAreaView>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
  },
  container: {
    flex: 1,
  },
  searchBarContainer: {
    alignItems: 'center',
    backgroundColor: theme.colors?.grey4,
    padding: 0,
    marginBottom: 10,
    borderBottomWidth: 0,
    borderTopWidth: 0,
  },
  searchBarnputContainer: {
    backgroundColor: theme.colors?.white,
  },
  listContentContainer: {
    paddingBottom: 50,
  },
}))
